import { AuthService } from 'src/app/pages/core/abstraction/auth.service';
import { IBundleBalance, ICryptoPortfolio } from './../../../../models/Crypto';
import { Component, Input, OnInit } from '@angular/core';
import { STATUS } from 'src/app/pages/core/models/Dca';
import { Router } from '@angular/router';

@Component({
  selector: 'app-crypto',
  templateUrl: './crypto.component.html',
  styleUrls: ['./crypto.component.scss'],
})
export class CryptoComponent implements OnInit {
  @Input()
  cryptoBalances: ICryptoPortfolio[] = [];
  @Input()
  cryptoBundleBalances: IBundleBalance[] = [];
  @Input() hiddenBundle;
  equivalentInArs = true;
  currency = 'ARS';

  object = Object;
  rulesActive: boolean = false;
  STATUS = STATUS;
  show: boolean;
  constructor(public authService: AuthService, private router: Router) {}

  changeCurrency(currency: string) {
    if (this.currency !== currency) {
      this.currency = currency;
      this.equivalentInArs = !this.equivalentInArs;
    }
  }

  ngOnInit(): void {
    this.authService.myCryptoPortfolio.subscribe((data: ICryptoPortfolio[]) => {
      if (this.cryptoBalances.length === 0 || this.cryptoBalances[0]?.name) {
        this.cryptoBalances = data
          .filter((balance) => {
            // Ocultar los balances que no tienen el minimo suficiente para mostrar en portfolio
            return Number(balance.balanceArs) >= 1;
          })
          .sort((a, b) => {
            if (a.ticker.includes('USDT')) return -1;
            return Number(b.balance) - Number(a.balance);
          });
        this.show = true;
      } else {
        this.show = false;
      }
    });

    this.authService.dcaRules.subscribe((resp) => {
      resp?.rules.map((rule) => {
        if (rule.status === STATUS.ACTIVE) this.rulesActive = true;
      });
    });
  }

  clickCard(balance) {
    this.router.navigate(['/grupos/trade'], { queryParams: { coin: balance.ticker } });
  }
}
